import React from 'react';

import classes from './MTabsPane.module.scss';

type Props<Tabs extends string> = {
  text: string | JSX.Element;
  className?: string;
  id: Tabs;
};

const MTabsPaneView = <Tabs extends string>(props: React.PropsWithChildren<Props<Tabs>>): JSX.Element => {
  return <div className={`${classes['container']} ${props.className || ''}`.trim()}>{props.children}</div>;
};

MTabsPaneView.displayName = 'MTabsPaneView';

export default MTabsPaneView;
